<template>

  <head>

    <meta charset="utf-8" />
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">


    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->


    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Approved Applications</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item active">E Construction</li>
                    <li class="breadcrumb-item active">Ongoing Applications</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->
          <div class="row">

            <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
              <div class="flex-grow-1">
                <div class="search-box mb-0 me-3">
                  <div class="position-relative">
                    <input v-model="search" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false" data-ms-editor="true">
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div v-if="loading" class="text-center my-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading applications...</p>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table align-middle table-striped table-nowrap table-hover dt-responsive contacts-table" id="datatable-buttons">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col" style="width: 3%">#</th>
                        <th scope="col" style="width: 8%">App. Date</th>
                        <th scope="col" style="width: 10%">BillNo</th>
                        <th scope="col" style="width: 12%">Project Name</th>
                        <th scope="col" style="width: 10%">Dev. Type</th>
                        <th scope="col" style="width: 8%">Sub County</th>
                        <th scope="col" style="width: 8%">Ward</th>
                        <th scope="col" style="width: 8%">Plot No.</th>
                        <th scope="col" style="width: 8%">Final Payment</th>
                        <th scope="col" style="width: 8%" class="text-end">Final Amount</th>
                        <th scope="col" style="width: 8%" class="text-end">Final Paid</th>
                        <th scope="col" style="width: 8%" class="text-end">Final Balance</th>
                        <th style="width: 8%"></th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-if="applications.length === 0">
                        <td colspan="13" class="text-center">No applications found</td>
                      </tr>

                      <tr v-for="(application, index) in applications" :key="application.id">
                        <td>{{ ((currentPage - 1) * rowsPerPage) + index + 1 }}.</td>
                        <td>{{ formatDate(application.created_at) }}</td>
                        <td>{{ application.billNoFinal }}</td>
                        <td class="text-truncate" style="max-width: 150px;" :title="application.project_title">
                          {{ application.project_title }}
                        </td>
                        <td>{{ capitalizeFirstLetter(application.development_type) }}</td>
                        <td>{{ application.subCountyName }}</td>
                        <td>{{ application.wardName }}</td>
                        <td>{{ application.plot_number }}</td>
                        <td>

                        <span :class="getPaymentStatusClass(application.finalPayment)">{{ application.finalPayment }}</span>
                        </td>
                        <td class="text-end">
                          <strong>{{ application.detailAmountFinal }}</strong>
                        </td>
                        <td class="text-end">
                          {{ application.receiptAmountFinal }}
                        </td>
                        <td class="text-end">
                          {{ application.billBalanceFinal }}
                        </td>

                        <td>
                          <button class="btn btn-sm btn-primary" @click="viewDetails(application.id)">
                            View Details
                          </button>

                          <button style="margin-left: 2px"
                              class="btn btn-sm btn-success"
                              @click="printConstructionPermit(application.id,application.finalPayment)">
                            Print Permit
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination Component -->
                  <div class="d-flex justify-content-between align-items-center mt-4">
                    <div>
                      <span class="me-2">Showing {{ applications.length ? ((currentPage - 1) * rowsPerPage) + 1 : 0 }} to {{ Math.min(currentPage * rowsPerPage, total) }} of {{ total }} entries</span>
                      <select v-model="rowsPerPage" class="form-select form-select-sm d-inline-block w-auto ms-2" @change="getApplications(1)">

                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                      </select>
                      <span class="ms-1">per page</span>
                    </div>
                    <nav aria-label="Page navigation">
                      <ul class="pagination pagination-md mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" href="#" @click.prevent="changePage(1)">First</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                            <span aria-hidden="true">&laquo;</span>
                          </a>
                        </li>

                        <!-- Show limited page numbers with current page in the middle when possible -->
                        <li v-for="page in getPaginationRange()" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                        </li>

                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                            <span aria-hidden="true">&raquo;</span>
                          </a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" href="#" @click.prevent="changePage(totalPages)">Last</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->


      <!-- Application Details Modal Component -->
      <ApplicationDetailsModal
          v-if="selectedApplicationId"
          :application-id="selectedApplicationId"
          :can-approve="true"
          :can-decline="true"
          @approve="handleApproveApplication"
          @decline="handleDeclineApplication"
          @download-invoice="downloadInvoice"
          @download-receipt="downloadReceipt"
      />



      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">
            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>



    <!-- end main content-->



  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>

</template>


<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ApplicationDetailsModal from "@/components/econstruct/inprogress/ApplicationDetailsModal.vue";
import {biller, econstruction, execute, trade} from "@/api";
import printReceipt from "../../../public/PrintDocs/Receipts/PrintReceipt.vue";

export default {
  name: "eConstructionProgress",
  components: {
    NavigationBar,
    ApplicationDetailsModal
  },
  data() {
    return {
      search: "",
      applications: [],
      loading: true,
      total: 0,
      currentPage: 1,
      rowsPerPage: 10,
      selectedApplicationId: null,
      searchTimer: null
    };
  },
  watch: {
    search() {
      // Add debounce to avoid excessive API calls while typing
      clearTimeout(this.searchTimer);
      this.loading = true;
      this.searchTimer = setTimeout(() => {
        this.getApplications(1);
      }, 500);
    },
  },
  computed: {
    printReceipt() {
      return printReceipt
    },
    totalPages() {
      return Math.ceil(this.total / this.rowsPerPage);
    }
  },
  mounted() {
    this.getApplications();
  },
  methods: {
    getApplications(page = 1) {
      this.loading = true;
      this.currentPage = page;

      const data = new FormData();
      data.append("function", "getApplications");
      data.append("page", page);
      data.append("rows_per_page", this.rowsPerPage);
      data.append("search", this.search);
      data.append("status", "approved");

      execute(data, econstruction)
          .then((res) => {
            if (res.data.success && res.data.data) {
              this.applications = res.data.data.applications;
              this.total = parseInt(res.data.data.total);
              this.rowsPerPage = parseInt(res.data.data.rows_per_page);
            } else {
              console.error("Failed to load applications");
              if (this.$toast) {
                this.$toast.error("Failed to load applications");
              }
            }
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error loading applications:", e);
            if (this.$toast) {
              this.$toast.error("Error loading applications: " + (e.message || "Unknown error"));
            }
          });
    },

    // Pagination utility to show reasonable number of page buttons
    getPaginationRange() {
      const maxVisiblePages = 5;
      let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

      // Adjust startPage if we're near the end
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      // Generate array of page numbers
      const pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.getApplications(page);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    },

    capitalizeFirstLetter(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getPaymentStatusClass(status) {
      if (!status) return 'badge bg-secondary';

      switch(status.toUpperCase()) {
        case 'PAID':
          return 'badge bg-success';
        case 'PARTIAL':
          return 'badge bg-warning';
        case 'UNPAID':
          return 'badge bg-danger';
        default:
          return 'badge bg-secondary';
      }
    },

    viewDetails(applicationId) {
      // Store the ID to trigger the component creation
      this.selectedApplicationId = applicationId;

      // Create a check function that will attempt to find and open the modal
      const checkAndOpenModal = () => {
        console.log("Attempting to open modal for application:", applicationId);
        const modalId = `details-${applicationId}`;
        const modalElement = document.getElementById(modalId);

        if (modalElement) {
          console.log("Modal element found, opening modal");
          if (window.$) {
            window.$(`#${modalId}`).modal('show');
          } else {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');
            const backdrop = document.createElement('div');
            backdrop.classList.add('modal-backdrop', 'fade', 'show');
            document.body.appendChild(backdrop);
          }
          return true; // Successfully opened
        }

        console.log("Modal element not found yet");
        return false; // Not found yet
      };

      // First attempt after a short delay
      setTimeout(() => {
        if (!checkAndOpenModal()) {
          // If first attempt failed, try again with a longer delay
          console.log("First attempt failed, trying again...");
          setTimeout(() => {
            if (!checkAndOpenModal()) {
              // If still failed, try one more time with even longer delay
              console.log("Second attempt failed, trying one last time...");
              setTimeout(checkAndOpenModal, 500);
            }
          }, 300);
        }
      }, 100);
    },

    handleApproveApplication(application, billNo) {
      console.log("Approve application:", application.id);
      // Show confirmation dialog
      if (confirm(`Are you sure you want to approve application ${application.application_number}?`)) {
        // Implement approval functionality
        const data = new FormData();
        data.append("function", "approveApplication");
        data.append("applicationId", application.id);
        data.append("billNo", billNo);

        execute(data, econstruction)
            .then((res) => {
              if (res.data.success) {
                if (this.$toast) {
                  this.$toast.success("Application approved successfully");
                }
                // Refresh applications list
                this.getApplications(this.currentPage);
                // Close the modal
                if (window.$) {
                  window.$(`#details-${application.id}`).modal('hide');
                }
              } else {
                console.error("Failed to approve application");
                if (this.$toast) {
                  this.$toast.error("Failed to approve application: " + (res.data.message || "Unknown error"));
                }
              }
            })
            .catch((e) => {
              console.error("Error approving application:", e);
              if (this.$toast) {
                this.$toast.error("Error approving application: " + (e.message || "Unknown error"));
              }
            });
      }
    },

    handleDeclineApplication(application) {
      console.log("Decline application:", application.id);
      // Show confirmation dialog with reason input
      const reason = prompt(`Please provide a reason for declining application ${application.application_number}:`);

      if (reason !== null) {
        // Implement decline functionality
        const data = new FormData();
        data.append("function", "declineApplication");
        data.append("applicationId", application.id);
        data.append("reason", reason);

        execute(data, econstruction)
            .then((res) => {
              if (res.data.success) {
                if (this.$toast) {
                  this.$toast.success("Application declined successfully");
                }
                // Refresh applications list
                this.getApplications(this.currentPage);
                // Close the modal
                if (window.$) {
                  window.$(`#details-${application.id}`).modal('hide');
                }
              } else {
                console.error("Failed to decline application");
                if (this.$toast) {
                  this.$toast.error("Failed to decline application: " + (res.data.message || "Unknown error"));
                }
              }
            })
            .catch((e) => {
              console.error("Error declining application:", e);
              if (this.$toast) {
                this.$toast.error("Error declining application: " + (e.message || "Unknown error"));
              }
            });
      }
    },

    downloadInvoice(application) {
      console.log("Download invoice for:", application.billNo);

      const data = new FormData();
      data.append("function", "downloadInvoice");
      data.append("billNo", application.billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data.pdfUrl) {
              // Open the PDF in a new tab
              window.open(res.data.data.pdfUrl, '_blank');
            } else {
              console.error("Failed to download invoice");
              if (this.$toast) {
                this.$toast.error("Failed to download invoice: " + (res.data.message || "Unknown error"));
              }
            }
          })
          .catch((e) => {
            console.error("Error downloading invoice:", e);
            if (this.$toast) {
              this.$toast.error("Error downloading invoice: " + (e.message || "Unknown error"));
            }
          });
    },

    downloadReceipt(application) {
      console.log("Download receipt for:", application.billNo);

      const data = new FormData();
      data.append("function", "downloadReceipt");
      data.append("billNo", application.billNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data.pdfUrl) {
              // Open the PDF in a new tab
              window.open(res.data.data.pdfUrl, '_blank');
            } else {
              console.error("Failed to download receipt");
              if (this.$toast) {
                this.$toast.error("Failed to download receipt: " + (res.data.message || "Unknown error"));
              }
            }
          })
          .catch((e) => {
            console.error("Error downloading receipt:", e);
            if (this.$toast) {
              this.$toast.error("Error downloading receipt: " + (e.message || "Unknown error"));
            }
          });
    },


    printConstructionPermit(applicationId,finalPayment) {

      if(finalPayment ==="UNPAID"){
        alert("The Final Payment has not been paid for")
        return;
      }

      const data = new FormData();
      data.append("function", "printConstructionPermit");
      data.append("applicationId", applicationId);
      execute(data, econstruction)
          .then((res) => {
            if (res.data.success) {

              localStorage['params'] = JSON.stringify({
                applicationId: applicationId
              })
              const routeData = this.$router.resolve({name: 'construction-permits'});
              window.open(routeData.href, '_blank');

            } else {
              alert(res.data.message)

            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
  }
};
</script>

<style scoped>
.text-right {
  text-align: right;
}

.badge {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}
</style>